import { TfoCookie } from '@tfo/common/src/utils/Cookie'
import Axios, { AxiosError, AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios'
import { get, remove } from 'js-cookie'
import { Language } from '../models/Enums'

export type HttpError = {
    message: string
    code?: string
}

const $http = {
    _cookieKey: 'tfoCustomerPortal',
    _baseUrl: ``,

    get: async function <T>(endpoint: string, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        await this._makeSureBaseUrlExists();
        return await this._promise<T>(Axios.get(this._getUrl(endpoint), this._getConfig(contentType, accept, responseType)))
    },

    post: async function <T>(endpoint: string, data: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        await this._makeSureBaseUrlExists();
        return await this._promise<T>(Axios.post(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    put: async function <T>(endpoint: string, data: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        await this._makeSureBaseUrlExists();
        return await this._promise<T>(Axios.put(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    patch: async function <T>(endpoint: string, data: any, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        await this._makeSureBaseUrlExists();
        return await this._promise<T>(Axios.patch(this._getUrl(endpoint), data, this._getConfig(contentType, accept, responseType)))
    },

    delete: async function <T>(endpoint: string, responseType?: string, contentType?: string, accept?: string): Promise<T> {
        await this._makeSureBaseUrlExists();
        return await this._promise<T>(Axios.delete(this._getUrl(endpoint), this._getConfig(contentType, accept, responseType)))
    },

    configureOptions: function (baseUrl: string) {
        this._baseUrl = baseUrl
    },

    _promise: async function <T>(promise: AxiosPromise): Promise<T> {
        return (await promise
            .then(response => {
                return response
            })
            .catch((error: AxiosError) => {
                console.error(error)
                const httpError: HttpError = {
                    ...error
                }
                throw httpError
            }) as AxiosResponse).data as T
    },


    _getBaseUrl: async function (): Promise<string> {
        return fetch('/individualapi_baseurl.json').then(r => r.json()).then(r => r.baseUrl);
    },

    _isValidHttpUrl: function (string: string): boolean {
        let url;
        try {
          url = new URL(string);
        } catch (_) {
          return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    },

    _makeSureBaseUrlExists: async function (): Promise<void> {
        if (this._isValidHttpUrl(this._baseUrl) === false)
        {
            this._baseUrl = await this._getBaseUrl();
        }
    },

    _getUrl: function (endpoint: string): string {
        return `${this._baseUrl}/${endpoint}`
    },

    _getConfig: function (contentType?: string, accept?: string, responseType?: string): AxiosRequestConfig {
        const cookie = this._getCookie();
        const userLanguage = localStorage.getItem('userLanguage') as Language
        const token = (window as any)?.tfoToken ? (window as any)?.tfoToken : cookie?.token;
        
        return {
            headers: {
                authorization: `bearer ${token}`,
                'content-type': contentType ?? 'application/json',
                accept: accept ?? 'application/json',
                'x-selected-language': userLanguage === 'Svenska' || userLanguage === null ? 'sv' : 'en',
            },
            responseType: responseType ?? 'json'
        }
    },

    _getCookie: function (): Partial<TfoCookie> {
        const rawCookieText = get(this._cookieKey)
        try {
            return rawCookieText ? JSON.parse(rawCookieText) : {}
        } catch (error) {
            console.error(error)
            remove(this._cookieKey)
            return {}
        }
    }
}

export default $http